export const GET_CRICKET_MATCHES_LIST_REQUEST = "GET_CRICKET_MATCHES_LIST_REQUEST";
export const GET_CRICKET_MATCHES_LIST_SUCCESS = "GET_CRICKET_MATCHES_LIST_SUCCESS";
export const GET_CRICKET_MATCHES_LIST_ERROR = "GET_CRICKET_MATCHES_LIST_ERROR";

export const GET_PLAYERS_LIST_REQUEST = "GET_PLAYERS_LIST_REQUEST";
export const GET_PLAYERS_LIST_SUCCESS = "GET_PLAYERS_LIST_SUCCESS";
export const GET_PLAYERS_LIST_ERROR = "GET_PLAYERS_LIST_ERROR";
